import { getCurrentInstance as l, reactive as s, computed as I, toValue as p } from "vue";
let c = 0;
const i = "OUIA-Generated-", f = {}, y = ({
  name: e = void 0,
  id: t = void 0,
  variant: d = void 0,
  safe: $ = !1
} = {}) => {
  var o, r;
  if (e === void 0) {
    const u = l();
    e = (r = ((o = u == null ? void 0 : u.proxy) == null ? void 0 : o.$options.name) || (u == null ? void 0 : u.type.__name)) == null ? void 0 : r.replace(/^pf-|^Pf/, "");
  }
  return s({
    "data-ouia-component-type": `PF/${e}`,
    "data-ouia-safe": $,
    "data-ouia-component-id": x(e, t, d)
  });
}, x = (e, t, d) => I(() => p(t) ?? P(e, d));
function P(e, t) {
  var d, $;
  if (e === void 0) {
    const o = l();
    e = ($ = ((d = o == null ? void 0 : o.proxy) == null ? void 0 : d.$options.name) || (o == null ? void 0 : o.type.__name)) == null ? void 0 : $.replace(/^pf-|^Pf/, "");
  }
  t = p(t);
  try {
    let o;
    return typeof window < "u" ? o = `${window.location.href}-${e}-${t || ""}` : o = `${e}-${t || ""}`, f[o] || (f[o] = 0), `${i}${e}-${t ? `${t}-` : ""}${++f[o]}`;
  } catch {
    return `${i}${e}-${t ? `${t}-` : ""}${++c}`;
  }
}
export {
  P as getDefaultOUIAId,
  x as useOUIAId,
  y as useOUIAProps
};
